// Small pill for a single active filter.  "Brand: ATK ×"
export default function FilterChip({ label, value, onRemove }) {
  return (
    <span className="inline-flex items-center gap-2 bg-[#141414] border border-[#1F1F1F] text-white px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.06em]">
      <span className="text-[#8A8A8A]">{label}:</span>
      <span>{value}</span>
      <button
        type="button"
        onClick={onRemove}
        aria-label={`Remove ${label} ${value}`}
        className="ml-1 text-white transition-transform duration-200 hover:rotate-45"
      >
        ×
      </button>
    </span>
  );
}
